<template>
  <div :height="true" class="assignTask">
    <!-- <div class="goback">
      <span @click="$router.back()">返回</span>
    </div> -->
    <div class="visitor-info pt-4 px-6" v-if="!showTask">
      <div class="w-full">
        <div class="topp font-bold">添加调查员</div>
        <el-form ref="visitorInfo" :model="visitorInfo"  label-width="140px"
               label-position="right">
         <el-form-item  prop="executorPhone" >
          <div class="elBody w-full justify-center">
          <div>
           <div class="inputb">
             <div class="addVisit">
               <span>调查员手机号</span>
             </div>
            <el-input
             type="textarea"
             class="textarea"
             placeholder="请参照以下格式输入（每行一个手机号）：
15233334444
15911112222
13847850348
13578048059"
             v-model="zidongArr1"
             v-loading="loading"
             >
            </el-input>
              <p class="footTip">全部 <span>{{tipLength.length}}</span> 条</p>
            </div>
            <br>
            <!-- <p class="spTip" v-show="pShow"><i class="el-icon-error iconTip"></i>共添加了<span class="sppTip">{{pArr.length}}</span>个手机号，其中有<span class="sppTip">{{lenn}}</span>个手机号合法</p> -->
            <el-button type="info" @click="nextClick" style="margin: 15px 0 0 590px;" :class="{ elBtn : isActive }">下一步</el-button>
            <el-button type="default" style="margin-left:10px；width:88px" @click="$emit('cancel')">取消</el-button>   
           </div>
          </div>
         </el-form-item>     
        </el-form>
      </div>
    </div>
    <el-dialog
          title="员工姓名不匹配提示"
          :visible.sync="dia_box"
          :modal="false"
          class="theme-dialog"
          width="30%">
          <p>您输入的调查员信息中，有<span class="task">{{this.errLength}}</span>名企业员工的姓名不匹配，将为您去掉当前填写名称，不会对已有信息和创建任务操作产生影响，请【确定】。</p>
          <br/>
          <p>如【取消】则不会去掉错误姓名。</p>
          <span slot="footer">
            <el-button @click="dia_box = !dia_box">取 消</el-button>
            <el-button type="primary" @click="diabox">确 定</el-button>
          </span>
    </el-dialog>

     <el-dialog
          :visible.sync="dia_box1"
          :modal="false"
          class="theme-dialog"
          width="30%">
          <p>共添加<span class="task">{{ pArr.length }}</span>个手机号，其中有<span class="task">{{this.lenn}}</span>个不合法。<span v-if="errPhoneIndex">分别在：</span>
          <div class="errPhone"> 
            <div v-for="(item,index) in errPhoneIndex" :key="index" v-show="errPhoneIndex">
              第<span class="task">{{ item }}</span>行<span class="gg"></span>
            </div>
          </div>
          <p v-show="errPhoneIndex">请修改</p>
          <p slot="title" style="font-size:20px;display:flex;align-items:center">
            <img src="@/assets/img/wj/感叹号.png" style="width:25px;height:25px;" alt="">
            <span style="margin-left:5px;font-size:20px">手机号不合法提示</span>
          </p>
          <span slot="footer">
            <el-button @click="dia_box1 = !dia_box1">取 消</el-button>
            <el-button type="primary" @click="diabox1">确 定</el-button>
          </span>
    </el-dialog>

    <div class="task-info pt-4 px-6" v-if="showTask" v-loading="loading1">
      <div class="top font-bold">任务信息</div>
      <el-form ref="taskInfo" :model="taskInfo" :rules="taskInfoRules" label-width="140px" label-position="right">
        <el-form-item label="任务名称:" prop="executionName">
          <el-input class="el-form-input" v-model="taskInfo.executionName" placeholder="问卷标题1"></el-input>
        </el-form-item>
        <el-form-item label="截止时间:" prop="executionValidateTo">
          <el-date-picker
            class="el-form-input"
            type="datetime" placeholder="选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="taskInfo.executionValidateTo"
            :picker-options="startDateDisabled"
          />
        </el-form-item>
        <el-form-item label="答卷数量（个）:" prop="executionQuantity">
          <el-input class="el-form-input" v-model="taskInfo.executionQuantity" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item label="答卷单价（元）:" prop="executionSingleAmount">
          <el-input class="el-form-input" v-model="taskInfo.executionSingleAmount" placeholder="支持两位小数，支持0和正数"></el-input>
        </el-form-item>
        <el-form-item label="预估费用:">{{ money }} 元</el-form-item>
        <el-form-item label="描述:" prop="executionDescription">
          <el-input class="el-form-input"  v-model="taskInfo.executionDescription" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-btn">
        <el-button @click="showTask = false">上一步</el-button>
        <el-button type="primary" @click="onClickSubmit" style="width:88px">确认</el-button>
        <el-button @click="$emit('cancel')" style="width:88px">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import differenceWith from 'lodash.differencewith'
  import intersection from 'lodash.intersection'
  import isEqual from 'lodash.isequal'
  import uniq from 'lodash.uniq'
  import { isNum } from '@/assets/js/utils'
  import { postAssignOfflineTask, getCheckPhone } from '@/api/wenjuan/offline'
  import { addList4Entrust } from "@/api/wenjuan/publishQuestion";
  import { mapGetters } from 'vuex';
  import {
    peopleList,
    plCreat,
    checkUser
  } from "@/api/wenjuan/addList";
  import GlobalConfig from "@/global/config"
  
  const testNum = /((^[0-9]\d*)|^0)(\.\d{0,2})?$/
  export default {
    name: 'assignTask',
    props: {
      entrustTaskId: {
        type: Number | String,
        default: ''
      }
    },
    created() {
      let len = this.$route.query.len || 1
      this.taskInfo.executionName = this.title + len // '面对面访问' + len
      // this._initPromise()
    },
    data() {
      const executionNameRules = (rule, value, callback) => {
        let v = this.taskInfo.executionName
        if (!v.trim()) {
          callback(new Error('请输入任务名称'))
        }
        callback()
      }
      const executionQuantityRules = (rule, value, callback) => {
        let v = this.taskInfo[rule.fullField]
        if (!isNum.test(v)) {
          callback(new Error('请输入有效数字'))
        }
        if (rule.fullField === 'executionSingleAmount') {
        } else if (v <= 0) {
          callback(new Error('不能为0'))
        }
        callback()  
      }
      const executionSingleAmountRules = (rule, value, callback) => {
        let v = this.taskInfo[rule.fullField]
        if (!testNum.test(v)) {
          let _v = Number(v)
          console.log(_v)
          if (!isNaN(_v)) {
            callback(new Error('最多支持两位小数'))
          } else {
            callback(new Error('请输入有效数字'))
          }
        }
         callback()
      }
      const executionValidateToRules = (rule, value, callback) => {
        let v = this.taskInfo.executionValidateTo
        if (!v) {
          callback(new Error('请选择结束时间'))
        }
        callback()
      }
      const startDateDisabled = {}
      startDateDisabled.disabledDate = function (time) {
        return (time.getTime() + 24 * 3600 * 1000) < Date.now()
      }
      return {
        search:{},
        page: {
          currentPage: 1,
          total: 0,
          layout: "total,pager,prev, next",
          background:false,
          pageSize: 10,
          pageSizes:[5,10,20,30,50,100]
        },
        aData:[],//左侧列表的数据
        zidongArr:[],//存放从列表勾选的数组
        zidongArr1:'',//存放手动输入的数组
        all:[],
        showTask:false,
        loading:false,
        loading1:false,
        hasPhone:[],
        hasPhone1:[],
        tipArr:[],
        apiPhone:[],
        nocheckPhone:[],
        isActive:false,
        hasP:[],
        b:[],
        keyLength:'',
         option:{
          menu:false,
          columnBtn: false, //设置列显隐按钮隐藏
          refreshBtn: false, //操作列下的刷新图标设为隐藏
          delBtn: false, //操作列下的删除图标设为隐藏
          editBtn: false, //操作列下的编辑图标设为隐藏
          addBtn: false, //操作列下的新增图标设为隐藏
          searchBtn:false,
          selection: true,
          // selectable:(row,index)=>{//显示已勾选的
          //   return index===1;
          // },
          reserveSelection:true,
          align:'center',
          // menuAlign:'center',
          column:[
             {
              label:'序号',
              prop:'index',
            }, {
              label:'ID-姓名-手机号',
              prop:'content'
            }
          ]
        },
        dia_box:false,
        dia_box1:false,
        lenn: 0,
        len1: 0,
        errLength:'',//姓名手机号不匹配的个数
        errPhoneIndex:[],
        value: [],
        pArr:[],//
        pArr1:[],
        visible:false,
        startDateDisabled,
        executionBy: '',
        visitorInfo: {
          executorPhone: ''
        },
        // visitorInfoRules: {
        //   executorPhone: [{ required: true, validator: phoneRules, trigger: 'change' }]
        // },
        taskInfo: {
          executionName: '',
          // executionValidateTo: '',
          // executionQuantity: 0,
          // executionSingleAmount: 0,
          // executionDescription: ''
        },
        taskInfoRules: {
          executionName: [{ required: true, validator: executionNameRules, trigger: 'blur' }],
          executionQuantity: [{ required: true, validator: executionQuantityRules, trigger: 'blur' }],
          executionSingleAmount: [{ required: true, validator: executionSingleAmountRules, trigger: 'blur' }],
          executionValidateTo: [
            {
              required: true,
              validator: executionValidateToRules,
              trigger: 'blur'
            }
          ],
          executionDescription: [{ min: 0, max: 255, message: '最长255个字符', trigger: 'blur' }]
        },
        promiseCb: null,
        promise: null
      }
    },
    computed: {
      tipLength(){
        // console.log(this.zidongArr1);
         if (this.zidongArr1 == '') {
          return []
        } else {
          this.hasPhone1 = []
          this.tipArr = []
         const a = this.zidongArr1.split("\n")
         for(let key in a){ //过滤掉因为误点产生的空数组
          if(a[key] === ''){
            continue
          }else{
            if(a[key].indexOf(',') === -1) {
              a[key] += ",$"
              this.hasPhone1.push(a[key])
            }
            this.tipArr.push(a[key])
          }
         }
         return this.tipArr
        }
      },
      money() {
        let { executionQuantity = 0, executionSingleAmount = 0 } = this.taskInfo
        return (executionQuantity * 100 * executionSingleAmount / 100 || 0).toFixed(2)
      },
      ...mapGetters(['title']),
      exPhone(){
        return this.zidongArr1
      }
    },
    watch:{
      exPhone(newValue, oldValue){
        newValue ? this.isActive = true : this.isActive = false
      }
    },
    methods: {
      searchChange(r) {
        console.log(r);
      },
      onLoad() {
        //获取调查员列表
        peopleList().then(res => {
          // console.log(res.data.data);
          this.page.total = res.data.data.length
          if(this.page.currentPage == 1){
            this.aData = res.data.data.slice(0,10).map((item,index)=> {
            return {  
              // userID:item.userID,
              index:index + 1, //序号
              content:item.userId + "-" + item.staffName + "-" + item.phone,
              nickname:item.nickname,
              staffName:item.staffName
            }
          })
          }
        }).catch(err => {
          console.log(err);
        })
      },
      sizeChange(val) {
        this.page.currentPage = 1
        this.page.pageSize = val
        this.onLoad()
        // this.$message.success('行数' + val)
      },
      currentChange(val) {
        this.page.currentPage = val
        this.onLoad()
      },
      selectionChange(list){
        this.zidongArr = [] 
        console.log(list);
        for(var i=0;i<list.length;i++){    
           this.zidongArr += list[i].nickname + "," + list[i].staffName + "\n"
        }
      },  
      diabox(){
        const aa = this.b.join('').split(',')//拿到接口返回的不匹配的电话和姓名 数组
        const bb = []//存放不匹配的手机号
        const cc = []//存放匹配的手机号
        const dd = []//存放没有姓名的手机号
        // this.zidongArr1 = this.b.join(",")
        // this.zidongArr1 = this.zidongArr1.replace(/,/g, "");
        // console.log(this.no);
        // const index1 = []
        // for(var i=0;i<this.b.length;i++){
        //   index1.push(this.pArr1.indexOf(this.b[i]))
        // }
        // console.log(index1)
        // index1.sort((a,b) => {
        //   return b-a
        // })
        // index1.forEach(index => {
        //   this.pArr1.splice(index+1, 1, '\n')
        // })
        // console.log(this.pArr1.join());
        // console.log(_.differenceBy(this.pArr1,aa)
        console.log(this.nocheckPhone);
        console.log(this.pArr1);
        console.log(aa);
        const sameArr = differenceWith(this.pArr1,aa,isEqual)//拿到匹配项
        console.log(sameArr);
        for(var i=0;i<sameArr.length;i=i+2){
          cc.push(sameArr[i] + ',' + sameArr[i+1] + '\n')
        }
        console.log(cc);
        for(var i=0;i<aa.length;i=i+2){
          bb.push(aa[i] + '\n')
        }
        console.log(bb.join(''));
        for(var i=0;i<this.nocheckPhone.length;i++){
          dd.push(this.nocheckPhone[i] + '\n')
        }
        this.zidongArr1 = bb.join('') + dd.join('') + cc.join('')
        console.log(this.visitorInfo.executorPhone);
        this.dia_box = !this.dia_box
      },
      diabox1(){
        console.log("手机号提示");
        this.dia_box1 = !this.dia_box1
      },
      later(a){
        setTimeout(()=>{
           if(this.nocheckPhone.length > 0 && this.nocheckPhone[0] !== ''){//包含只有手机号或者手机号和手机号+姓名的信息
             console.log(this.nocheckPhone);//不含有$符号的没带姓名的手机号
             console.log(this.pArr1);//全部数据
             var index = [] //找到存在手机号的索引
             for(var i=0;i<this.nocheckPhone.length;i++){
               index.push(this.pArr1.indexOf(this.nocheckPhone[i]))
             }
             console.log(index);//存在的手机号所在索引
            //  for(var j=0;j<index.length;j++){
            //    this.pArr1.splice(index[j],1)
            //    this.pArr1.splice(index[j+1],1)
            //  }
             index.sort((a,b) => {
               return b-a
             })
             index.forEach(index => {
               this.pArr1.splice(index, 2)
             })
             console.log(this.pArr1);
             if(intersection(this.nocheckPhone,this.pArr1).length > 0){
               this.$message.warning('当前输入的手机号中存在重复输入')
               this.loading = false
             }else if(this.pArr1.length == 0){//说明当前输入的数据 都是没有姓名的数据
               if(uniq(this.nocheckPhone).length != this.nocheckPhone.length){
                  this.zidongArr1 = uniq(this.nocheckPhone).join('\n')
                  this.isActive = true
                  this.loading = false
                  this.$message.warning('添加的调查员手机号有重复，已为您去重')
               }else{
                 const p = this.hasPhone.join(',').split(',')
                 this.visitorInfo.executorPhone = p
                 console.log(this.visitorInfo.executorPhone);
                 this.loading = false
                 this.$message.success('添加成功')
                 this.showTask = true
               }   
             }else{
               const a = []
               for(var i=0;i<this.pArr1.length;i=i+2){
                a.push({//a为去掉没有姓名的手机号 手机号+姓名的数组
                 phone: this.pArr1[i],
                 name:this.pArr1[i+1],
                })
               }
               console.log(a);
               checkUser(a).then(res => {//检测手机号姓名是否匹配
                if(res.data.data.length > 0){
                 this.errLength = res.data.data.length
                 this.loading = false
                 this.dia_box = true
                 this.b  = res.data.data.map(item => {
                   return item.phone + ',' + item.name
                 })
                }else{
                  console.log(this.hasPhone.join().split(','));
                  const p = this.hasPhone.join().split(',')
                  this.zidongArr1 = p.concat(this.pArr1)//拿到输入的全部手机号
                  this.visitorInfo.executorPhone = this.zidongArr1
                  console.log(this.visitorInfo.executorPhone);
                  this.loading = false
                  this.$message.success('添加成功')
                  this.showTask = true
                }
               }).catch(err => {
                 this.loading = false
                console.log(err);
               })
             }

           }else{//当只输入手机号+姓名的调查员时
            const a = []
            for(var i=0;i<this.pArr1.length;i=i+2){
              a.push({
                phone: this.pArr1[i],
                name:this.pArr1[i+1],
              })
            }
            checkUser(a).then(res => {
             console.log(res);
             if(res.data.data.length > 0){
               this.errLength = res.data.data.length
               this.loading = false
               this.dia_box = true
               this.b  = res.data.data.map(item => {
                  return item.phone + ',' + item.name
               })
             }
             else{
              //  const p = []
              //  for(var k=0;k<this.pArr1.length;k=k+2){
              //    p.push(this.pArr1[k])
              //  }
              //  console.log(p);//拿到带有姓名的手机号
               console.log(this.hasPhone.join().split(','));
               this.zidongArr1 = this.hasPhone.concat(this.pArr1)//拿到输入的全部手机号
               console.log(this.zidongArr1);
               this.visitorInfo.executorPhone = this.zidongArr1
               console.log(this.visitorInfo.executorPhone);
               this.loading = false
               this.$message.success('添加成功')
               this.showTask = true
              }
             }).catch(err => {
               this.loading = false
              console.log(err);
             })
            }
        },1000)
      },
      nextClick(){
        this.loading = true
        const phoneReg = /^1(3|4|5|7|8|9)\d{9}$/
        this.lenn = 0 
        this.len1 = 0
        this.pArr=[]//最终数组
        this.hasP = []
        this.hasPhone = []
        this.errPhoneIndex = []
        this.visitorInfo.executorPhone = []
        console.log(this.zidongArr1);
        if(this.zidongArr1.length > 0){
           let v = this.zidongArr1
         // console.log(v.split("\n"));
         const a = v.split("\n")
         for(let key in a){ //过滤掉因为误点产生的空数组
          if(a[key] === ''){
            continue
          }else{
            if(a[key].split(',').length-1 > 1) {
              this.keyLength = 1
            }
          }
         }  
        console.log(this.keyLength);
        // if(this.zidongArr1.indexOf(",") !== -1 && this.zidongArr1.indexOf("\\n") !== -1){
         if(this.zidongArr1.length > 2 && this.keyLength !== 1){
         let v = this.zidongArr1
         // console.log(v.split("\n"));
         const a = v.split("\n")
         for(let key in a){ //过滤掉因为误点产生的空数组
          if(a[key] === ''){
            continue
          }else{
            if(a[key].indexOf(',') === -1) {
              a[key] += ",$"
              this.hasPhone.push(a[key])
            }
            this.pArr.push(a[key])
          }
         }
       //检测手机号是否存在
       
          var hp = this.hasPhone.join().split(',')
          for(var i=0;i<hp.length;i=i+2){
            this.hasP.push(hp[i])
          }
        this.nocheckPhone = this.hasP //已经存在的手机号 （不用验证）：没有姓名的手机号

        this.pArr1 = this.pArr.join(",").split(",")
        var lenn = 0 
        console.log(this.pArr1);//去空后手动输入的数组

        for(var i=0;i<this.pArr1.length;i=i+2){
          if(phoneReg.test(this.pArr1[i])){
            this.lenn = this.lenn + 0
          }else{
            this.errPhoneIndex.push(Math.ceil((i+1)/2));
            this.lenn = this.lenn + 1
           }
          }
           if(this.lenn != 0){
            this.loading = false
            this.dia_box1 = true
           }else{//说明电话号码正确 开始验证手机姓名匹配
            this.later(a)
           }
         }
        else{
          this.loading = false
          this.$message.warning('未按照规定格式输入,请重新输入')
        }
        }else{
          this.loading = false
          this.$message.warning('当前未输入手机号，请输入后再试')
        }
        // // this.all = this.zidongArr + this.zidongArr1
        // this.all = this.zidongArr1
        // this.visitorInfo.executorPhone = this.all.split('\n').join().split(',')
        // console.log(this.visitorInfo.executorPhone);
      },
      onClickSubmit() {
        this.loading1 = true
        let taskInfo = this.$refs.taskInfo
        let visitorInfo = this.$refs.visitorInfo
        let arr = [
          {
            vueComponent: taskInfo,
            validateArr: ['executionName', 'executionQuantity', 'executionSingleAmount', 'executionValidateTo'],
          },
          {
            vueComponent: visitorInfo,
            validateArr: ['executorPhone'],
          },
        ]
        console.log(this.visitorInfo.executorPhone);
        //  this.$refs.visitorInfo.validate((valid) => {
        //   if (valid) {
          if(this.entrustTaskId){
             this.$refs.taskInfo.validate((valid) => {
              if(valid){
                var p = {
                  phones:[],
                  ...this.taskInfo,
                }
                for(var i=0;i<this.visitorInfo.executorPhone.length;i=i+2){
                      p.surveyId = GlobalConfig.getSurveyId(),
                      p.executionBy = this.executionBy,
                      p.phones.push({
                         phone: this.visitorInfo.executorPhone[i],
                         username: this.visitorInfo.executorPhone[i+1]
                      }),
                      p.entrustTaskId = this.entrustTaskId
                }
                  addList4Entrust(p).then((res) => {
                    this.loading1 = false
                    if(res.data.code!=0) {
                      this.$message.error(res.data.msg)
                      return;
                    }
                    this.$emit('cancel')
                    //this.$router.push({ path: this.proxy_executionq$$path + '?id=' + GlobalConfig.getSurveyId() })
                  }).catch((err) => {
                    this.loading1 = false
                    console.log(err);
                  })
              }else{
                this.loading1 = false
               console.log('error submit!!');
               return false;
              }
            })
          }else{
            this.$refs.taskInfo.validate((valid) => {
              if(valid){
                var p = []
                for(var i=0;i<this.visitorInfo.executorPhone.length;i=i+2){
                    p.push({
                      surveyId: GlobalConfig.getSurveyId(),
                      ...this.taskInfo,
                      executionBy: this.executionBy,
                      executorPhone: this.visitorInfo.executorPhone[i],
                      userName:this.visitorInfo.executorPhone[i+1],
                    })
                }
                  plCreat(p).then((res) => {
                    console.log(res);
                    this.loading1 = false
                     if(res.data.code!=0) {
                      this.$message.error(res.data.msg)
                      return;
                    }
                    this.$emit('cancel')
                    //this.$router.push({path: this.random_interview$$path + '?id='+GlobalConfig.getSurveyId()})
                  }).catch((err) => {
                    this.loading1 = false
                    console.log(err);
                  })
              }else{
                this.loading1 = false
               console.log('error submit!!');
               return false;
              }
            })
          }
            
        //   } else {
        //     console.log('error submit!!');
        //     return false;
        //   }
        // });
      },
    }
  }
</script>

<style scoped lang="scss">
.inputModel{
  width: 250px;
  height: auto;
  border: 1px solid rgb(220, 223 ,230);
  border-radius: 5px;
}
.input_span{
  border: 1px solid rgb(233, 233, 235);
  background-color: rgb(244, 244, 245);
  border-radius: 5px;
  margin-left: 5px;
}
.icon_i{
  margin-left:8px;
  cursor: pointer;
}
::v-deep .dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-button--medium {
    margin-right: 0 12px;
    width: 100px !important;
  }
}
::v-deep .dialog_button {
  /*设置按钮样式排列 */
  display: flex;
  justify-content: space-between;
  margin-top: -20px;
  margin-bottom: 10px;
}
::v-deep .el-transfer-panel {
  width: 470px !important;
}
::v-deep .el-transfer__buttons {
  /*设置按钮样式排列 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .el-button--primary,
  .is-disabled {
    margin-top: -40px;
    margin-left: 9px;
  }
}
::v-deep .el-transfer__buttons {
  button:first-child {
    position: absolute;
    bottom: 195px;
    background: white;
    color: #409EFF;
  }
}
::v-deep .el-dialog__body {
  border: 1px solid #dcdfe6;
  border-left: none;
  border-right: none;
}
  .assignTask {
    .goback {
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }

    .visitor-info {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .task-info {
      border: 1px solid #f2f6fc;
      margin-bottom: 30px;

      ::v-deep .top {
        font-size: 16px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.7);
      }

      .el-form {
        width: 560px;
        margin: 0 auto;

        .el-form-item {
          margin-bottom: 22px;
        }

        .el-form-input {
          width: 400px;
        }
      }
    }

    .task-info {
      margin-bottom: 0;
    }
    
    .submit-btn {
      margin-top: 30px;
      text-align: center;
    }
  }
.task{
  color: rgb(106, 170, 246);
  font-size: 20px;
  font-weight: bold;
  margin: 0 5px;
}
  
  ::v-deep .el-table{
    margin-top: 14px;
  }
  .nn{
    height: 36px!important;
  }
  .elBody{
    display: flex;
    align-items: center;
  }
  .textarea{
    width: 800px;
    position: relative;
  }
  ::v-deep .el-form-item__content{
    margin-left: 0!important;
  }
  ::v-deep .el-textarea__inner{
    height: 600px;
    min-height: 420px;
    // margin-top: -50px;
    // margin-left: 140px;
  }
  .add_css{
    margin-left: 140px;
  }
  .addVisit{
    width: 800px;
    height: 30px;
    margin-top: 30px;
    line-height: 30px;
    font-weight: bold;
    
  }
  .topp {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.7);
  }
  .bottom_btn{
    margin-left: 680px;
   
  }
  .elBtn{
     background:rgb(34,127,254);
     border:rgb(34,127,254);
     height: 32px;
  }
  .footTip{
    position: absolute;
    bottom: 90px;
    left: 625px;
  }
  .inputb{
  }
  .spTip{
    position: absolute;
    bottom: 0px;
    right: 360px;
    background: rgb(254, 240, 240);
    padding: 0px 20px;
    color: rgb(245, 108, 108);
    font-weight: bold;
  }
  .sppTip{
    font-size: 20px;
    padding: 0 5px;
  }
  .iconTip{
    color: rgb(245, 108, 108);
    margin-right: 8px;
  }
  ::v-deep.el-form-item__error{
    margin-left: 150px;
  }
  .errPhone{
    display: flex;
    align-items: center;
  }
  .errPhone div span:last-child::after{
    content: '，';
  }
  .errPhone div:last-child span:last-child::after{
    content: '。';
  }
</style>
